import { createTheme } from "@mui/material/styles";
export const theme = createTheme({
  palette: {
    primary: {
      main: "#181919",
      medium: "#212125",
      faint: "#333333",
    },
    secondary: {
      main: "#91DD03",
    },
    text: {
      primary: "#fff",
      secondary: "#91DD03",
    },
  },
});
